module.exports = __webpack_public_path__ + "assets/img/00033.52e3ae1a.png";